import { render, staticRenderFns } from "./SmartReportItem.vue?vue&type=template&id=18c5afaa&scoped=true"
import script from "./SmartReportItem.vue?vue&type=script&lang=js"
export * from "./SmartReportItem.vue?vue&type=script&lang=js"
import style0 from "./SmartReportItem.vue?vue&type=style&index=0&id=18c5afaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c5afaa",
  null
  
)

export default component.exports